import { addRecoilKey } from '@infield/utils/recoil';
import { atom } from 'recoil';

export const selectedActivityInPanelAtom = atom<string>({
  key: addRecoilKey('activity-panel-selected-activity'),
  default: '',
});
